import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseConfigurableComponent} from '@twpub/shared/components/base';
import {ClientConfigurationScheme, ComponentConfiguration, ComponentInit, InitialConfig} from '@twpub/core/utils';
import {FieldProps, SearchField} from '@twpub/core/models';
import {ComponentCategory, ControlType} from '@twpub/core/enums';
import { NgClass } from '@angular/common';
import {MatFormField, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatIcon} from '@angular/material/icon';
import {FilterButtonComponent} from './filter/filter-button/filter-button.component';

@Component({
  selector: 'pub-default-search-field',
  templateUrl: './default-search-field.component.html',
  styleUrls: ['./default-search-field.component.scss'],
  standalone: true,
  imports: [MatFormField, NgClass, MatInput, FormsModule, MatSuffix, MatIcon, FilterButtonComponent]
})
export class DefaultSearchFieldComponent extends BaseConfigurableComponent implements SearchField {
  static readonly SHOW_FILTER_BUTTON = 'showFilterButton';

  @Input() autoComplete: boolean = true
  @Input() rtl: boolean = false
  @Output() searchFor = new EventEmitter<string>()

  searchTerm: string = ''
  showFilterButton: boolean = false;

  constructor() {
    super();
  }

  static Init = class extends ComponentInit {
    override props: FieldProps[] = [this.VISIBLE_FIELD, this.LABEL_FIELD,
      {
        key: DefaultSearchFieldComponent.SHOW_FILTER_BUTTON,
        label: 'Show filter button',
        controlType: ControlType.Boolean,
        description: 'Display a button with a dropdown for filter configurations'
      }
    ];

    readonly scheme = ClientConfigurationScheme.DEFAULT;

    constructor() {
      super(DefaultSearchFieldComponent, 'DefaultSearchFieldComponent', 'Default Search Field', [ComponentCategory.SearchField]);
    }

    createConfig(initialConfig: InitialConfig = undefined) {
      return new ComponentConfiguration<SearchField>(DefaultSearchFieldComponent, this.name, initialConfig);
    }
  }

  override doUpdate(): void {
    super.doUpdate();
    this.showFilterButton = this.config?.getBoolean(DefaultSearchFieldComponent.SHOW_FILTER_BUTTON, false);
    this.cssClassName += this.rtl ? ' rtl' : '';
  }

  searchClick() {
    this.searchFor.emit(this.searchTerm)
  }
}
